import { lazy } from 'react';
import { adaptiveWrapperOptions } from '../../../appComponents/ModalWrapper';
import { screenOptionsForLightMode } from '../../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { CommentChatOnboardingFlowProps } from './CommentChatOnboardingFlowContent';

const CommentChatOnboardingFlowContent = lazy(
  () => import('./CommentChatOnboardingFlowContent'),
);

export const CommentChatOnboardingFlow = wrapLazyNavigatorScreen(
  (props: CommentChatOnboardingFlowProps) => {
    return <CommentChatOnboardingFlowContent {...props} />;
  },
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? screenOptionsForLightMode({
          presentation: 'card',
        })
      : screenOptionsForLightMode({
          presentation: 'transparentModal',
          cardOverlayEnabled: true,
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: false,
          headerShown: false,
        }),
  ),
);
